import React from 'react';
import { usePreview } from './usePreview';
import { Context } from './Context';
export const Preview = props => {
  const result = usePreview();

  if (!result.display) {
    return null;
  }

  const {
    display: _display,
    ...data
  } = result;
  let child;

  if ('children' in props) {
    if (typeof props.children === 'function') {
      child = props.children(data);
    } else {
      child = props.children;
    }
  } else {
    child = props.generator(data);
  }

  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: data
  }, child);
};